'use strict';

Object.defineProperty(exports, "__esModule", {
		value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    font-size: 14px;\n    font-family: "Open Sans", arial;\n    color: ', ';\n    padding: 0.4em;\n\tline-height:1.5rem;\n\t\n\t&:not([type="radio"]):not([type="checkbox"]){\n\t\tborder:1px solid #a9a9a9;\n\t\tmargin-top:0.4em;\n\t\tmargin-bottom:0.4em;\n\t}\n\t\n\t&.input-error{\n\t\tborder-bottom:1px solid #ff0000 !important;\n\t}\n\t\n    &:disabled{\n\t\tbackground:#ebebe4;\n\t\tcolor:#aaa;\n    }\n\t\n    ', '\n  }};\n'], ['\n    font-size: 14px;\n    font-family: "Open Sans", arial;\n    color: ', ';\n    padding: 0.4em;\n\tline-height:1.5rem;\n\t\n\t&:not([type="radio"]):not([type="checkbox"]){\n\t\tborder:1px solid #a9a9a9;\n\t\tmargin-top:0.4em;\n\t\tmargin-bottom:0.4em;\n\t}\n\t\n\t&.input-error{\n\t\tborder-bottom:1px solid #ff0000 !important;\n\t}\n\t\n    &:disabled{\n\t\tbackground:#ebebe4;\n\t\tcolor:#aaa;\n    }\n\t\n    ', '\n  }};\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _iaReact = require('ia.react.colorlist');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Input = _styledComponents2.default.input(_templateObject, _iaReact.COLORS.grey5, function (props) {
		return (props.type === "radio" || props.type === "checkbox") && '\n\t\tmargin: 0 0.4em 0 0;\n    ';
});

exports.default = Input;